import { render, staticRenderFns } from "./CompassRose.vue?vue&type=template&id=1cb1a354&"
import script from "./CompassRose.vue?vue&type=script&lang=js&"
export * from "./CompassRose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports